/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// import { PdfViewerComponent, Toolbar, Magnification, Navigation, LinkAnnotation, BookmarkView, ThumbnailView, Print, TextSelection, Annotation, TextSearch, FormFields, FormDesigner, Inject } from '@syncfusion/ej2-react-pdfviewer';
// import { DialogComponent } from '@syncfusion/ej2-react-popups';
// import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

import Navbar from './Navbar1';
import ProfilePic from '../data/logo 2.png';
// import Pdf from '../data/W3TechnicalSpecificationsOfficial.pdf';
import Footer1 from './Footer1';

const Solutions = () => {
  const navigate = useNavigate();
  const items = [
    'Our new product, W3, is a state-of-the-art wearable that tracks physiological parameters such as heart rate, core body temperature, heart rate variability, blood oxygen, respiratory rate, fatigue, and dehydration. It sends real-time alerts and notifications directly to users and supervisors mobile phones, enabling prompt response to potential risks.',
    'In addition, we have developed a gas monitor that connects seamlessly via Bluetooth to the W3 device. This allows for immediate gas alert notifications through the same connected application, providing an integrated safety solution for environments where gaseous exposure is a concern. A single-gas and four-gas model will be available.',
    'Our connected system ensures that everyone in the operational environment can be protected against heat stress and gas hazards efficiently and effectively.',
  ];

  useEffect(() => {
    // passing getData method to the lifecycle method
    const getData = async () => {
      await axios.get('https://api.ipify.org/?format=json').then((res) => {
        if (res && res.data && res.data.ip && (!res.data.ip.includes('162.237.130.3') && !res.data.ip.includes('104.183.248.155') && !res.data.ip.includes('63.249.41.231') && !res.data.ip.includes('24.155.131.7'))) {
          navigate('/notfound');
        }
      })
        .catch((error) => {
          console.error('solution', error);
        });
    };
    getData();
  }, []);
  // const [showPdf, setShowPdf] = useState(false);
  // const [displayFile, setDisplayFile] = useState('');
  // const maw = `${window.location.origin}/w3realtime.pdf`;
  // const w3Brochure = `${window.location.origin}/W3TechnicalSpecificationsOfficial.pdf`;
  /*
  const displayPdf = (file) => {
    setDisplayFile(file);
    setShowPdf(!showPdf);
  };
  const pdfView = () => (
    <div className="control-section">
      <PdfViewerComponent
        id="container"
        documentPath={displayFile}
        resourceUrl="https://cdn.syncfusion.com/ej2/31.2.2/dist/ej2-pdfviewer-lib"
        style={{ height: '640px' }}
      >
        <Inject services={[Toolbar, Magnification, Navigation, Annotation, LinkAnnotation, BookmarkView,
          ThumbnailView, Print, TextSelection, TextSearch, FormFields, FormDesigner]}
        />
      </PdfViewerComponent>
    </div>
  );
  const pdfbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setShowPdf(!showPdf);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  */

  return (
    <div className="home-container" style={{ width: '1800px' }}>
      <div className="nav-bar-bg">
        <Navbar />
      </div>
      <div className="work-section-wrapper">
        <div className="testimonial-section-bottom">
          <div>
            <p className="primary-subheading">Solution</p>
            <img src={ProfilePic} width={80} alt="" />
            <div className="primary-text">
              <ul>
                {items.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
            {/* <a href={Pdf} target="_blank" rel="noreferrer">...learn more</a> */}
            {/*
            <div className="flex primary-text">
              <label htmlFor="pdf1">Learn More</label>
              &nbsp;<ButtonComponent cssClass="e-small" iconCss="e-icons e-export-pdf-2" style={{ float: 'right' }} onClick={() => { displayPdf(w3Brochure); }}>W<sup>3</sup> Specification</ButtonComponent>&nbsp;
              <ButtonComponent cssClass="e-small" iconCss="e-icons e-export-pdf-2" style={{ float: 'right' }} onClick={() => { displayPdf(maw); }}>W<sup>3</sup> Real-Time</ButtonComponent>&nbsp;
            </div>
            {showPdf && (
              <DialogComponent
                header="PDF View"
                content={pdfView}
                buttons={pdfbuttons}
                width="65%"
                height="85%"
                id="pdf1"
                isModal
                visible
                closeOnEscape
                showCloseIcon
                onClose={() => { setShowPdf(!showPdf); }}
                close={() => { setShowPdf(!showPdf); }}
              />
            )}
            */}

          </div>
        </div>
        <div className="flex primary-text">
          <a href="https://cta-na2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLIqB%2B%2B1T5ozxg1LHdJsaxZYmKjSvMqExAh%2F6MqrDJ3ipbZah5piVNYlnRPRrFezomE8jnh0Iq72gFtkKwUw7BApRwMsFk6T8f7JqROivXXh1RBXoQHufxaCpQTp%2FbE6XUqe%2FNsa9NUJjcv%2BxvI1NKDxfdoJtuDMK2UGkW2fB1rweuehl0e3oDTjcB1JCQLRSOCeKzhXJWsIMR9JG%2FWxVMgcDsihr7N0xFpZjSOhp%2FABhg%3D%3D&webInteractiveContentId=313421247165&portalId=242306328" target="_blank" rel="noopener noreferrer">
            <img
              alt="&lt;p&gt;W3 Technical Specifications&lt;/p&gt;"
              loading="lazy"
              src="https://hubspot-no-cache-na2-prod.s3.amazonaws.com/cta/default/242306328/interactive-313421247165.png"
              style={{ height: '100%', width: '100%', 'object-fit': 'fill' }}
              onError="this.style.display='none'"
            />
          </a>
        </div>
        <div className="flex primary-text">
          <a href="https://cta-na2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLJBc10QcAofgDUyLAbeer%2BquHB%2FxUCyUUysQ1ZetsoSer%2FKp%2BrdTlIt1MFrueb9PcIi6Jz%2BUoKHTG4bcE9BMx9igiD%2BRtcYnVpscPs5jfG9OO7RhshyrB7TimlGyfbBcnmZwdexLpN7U6b7gbf42FD9%2BfBmoGexQKRPCn1WnZ1yXzNhBJPeu70KHd8aPPM9UiBtB1hZjGbpMNATvd87gEcnqamaiAEIoEvhcbc%3D&webInteractiveContentId=317868520152&portalId=242306328" target="_blank" rel="noopener noreferrer">
            <img
              alt="&lt;p&gt;Learn More&lt;/p&gt;"
              loading="lazy"
              src="https://hubspot-no-cache-na2-prod.s3.amazonaws.com/cta/default/242306328/interactive-317868520152.png"
              style={{ height: '100%', width: '100%', 'object-fit': 'fill' }}
              onError="this.style.display='none'"
            />
          </a>
        </div>
      </div>
      <Footer1 />
    </div>
  );
};

export default Solutions;
